import React from 'react'
import { Box, TextField, Button, Card, Typography, Avatar, InputAdornment, IconButton } from '@mui/material'
import { useRedirect } from 'react-admin'
import CryptoJS from 'crypto-js'
import axios from 'axios'
import generateToken from '../../utils/generateToken'
import authProvider from '../../utils/authProvider'
import globalStyles from '../../utils/globalStyles'
import LoginImg from '../../static/assets/Login.png'
import LogoWhite from '../../static/assets/LogoWhite.png'
import hnakLogo from '../../static/assets/shababuna_logo.png'
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import loginBg from '../../static/assets/loginBg.png'

import './styles.css';

// import 'bootstrap/dist/css/bootstrap.css';

function LoginPage(props) {
  const [usernameVal, setUsernameval] = React.useState('')
  const [passwordVal, setPasswordVal] = React.useState('')
  const [loginError, setLoginError] = React.useState(false)
  const [loginErrormsg, setLoginErrormsg] = React.useState(null)
  const [showPass, setShowPass] = React.useState(false)
  const redirect = useRedirect()


  
  
  const handleSignin = async () => {
    const data = {
      "username": usernameVal,
      "password": passwordVal
    };
    try {
    const loginRes = await authProvider.login(data)
    console.log("loginsucess",loginRes);
    if (loginRes.success) {
      redirect('/')
    } 
     }catch (error) {
      // If login fails, display the error message
      console.log("Login failed:", error);
      setLoginError(true);
      setLoginErrormsg(error);
      setTimeout(() => {
          setLoginError(false);
          setLoginErrormsg(null);
      }, 3000);
  }
};

  const containerStyle = {
    // height: '100vh', 
    width: '100vw', 
    margin: '0 !important', 
    padding: '0 !important',
    // backgroundImage: `url(${LoginImg})`,
      // backgroundImage: `url(${loginBg})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    backgroundColor:'#24554e !important'
  }
  const cardStyle = {
    display: 'block', 
    // width: '450px', 
    width:'100%',
    maxWidth:'450px !important',
    height: 'auto',
    minHeight: '85vh' ,
    borderRadius: '0px', 
    marginTop: '60px',
    // marginRight: '150px',
    '& .MuiBox-root': {
      display: 'grid'
    },
    '& .MuiFilledInput-input': {
      paddingLeft: '35px',
      paddingRight: '20px'
    },
    '& .MuiInputLabel-root': {
      left: '20%',
      color: '#2b3f7a !important'
    },
    '& .MuiFilledInput-root': {
      margin: '0% 15% !important',
      borderRadius: '25px !important',
      backgroundColor: '#F0F8FF !important'
    },
    '& .MuiFilledInput-root:before': {
      border: 'none !important'
    },
    '& .MuiInput-root:before': {
      border: 'none !important'
    },
    '& .MuiInput-root:after': {
      border: 'none !important'
    },
    '& .MuiFilledInput-root:after': {
      borderBottom: 'none !important'
    }
  }
  const buttonStyle = {
    backgroundColor: '#2b3f7a !important', 
    color: '#fff !important', 
    textTransform: 'capitalize', 
    width: '200px', 
    borderRadius: '25px', 
    padding: '10px', 
    fontSize: '1rem'
  }
 
  return (
    <>
    <div className='container-fluid bg' sx={containerStyle} style={{backgroundColor:"#24554e", minHeight:"100vh"}}>

    <div className='container-fluid' style={{ backgroundColor:"#24554e"}}>
      <div className='row' style={{ backgroundColor:"#24554e"}}>
        <div className='col-xxl-7 col-xl-7 col-lg-6 col-md-12 col-sm-12'>
          <div className='row'>
            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center'>
              <img src={LogoWhite} alt='Shababuna' width="120px" className='logo-margin' />
            </div>
            <div className='col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 text-center'>
              <img src={LoginImg} alt='Shababuna' className="login-banner-size"/>
            </div>
          </div>
        </div>
        
        <div className='col-xxl-5 col-xl-5 col-lg-5 col-md-12 col-sm-12'>

        <Card sx={cardStyle} className='login-box'>
          <Box sx={{ justifyContent: 'center', marginTop: '40px' }}>
            {/* Avatar */}
            <img src={hnakLogo} alt='HNAK logo' sx={{ height: '90px', width: '90px' }} style={{borderRadius:"0", width:"75px"}}/>
          </Box>
          <Box sx={{ margin: '5% 0% 2% !important', textAlign: 'center', padding: '20px 0px 10px', color: '#778899 !important', minHeight: '80px' }}>
            <Typography variant='body2' sx={{ fontSize: '1.3rem', fontWeight: 600 }}>
              Welcome, please sign in
            </Typography>
          </Box>
          {loginError && loginErrormsg && (
            <Box>
            <Typography variant='body2' sx={{ textAlign: 'center', paddingTop: '1px',marginTop:'-30px', color: 'red', fontSize: '.9rem', fontWeight: 20 }}>
            {loginErrormsg}
            </Typography>
            </Box>
          )}
          <Box>
            <TextField label='Username' value={usernameVal} onChange={(e) => setUsernameval(e.target.value)} />
            <TextField label='Password' value={passwordVal} onChange={(e) => setPasswordVal(e.target.value)} 
              type={showPass ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPass(!showPass)}>
                      {showPass ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
          />
          </Box>
          <Box sx={{ justifyContent: 'center', paddingTop: '30px' }}>
            <Button onClick={() => handleSignin()} sx={buttonStyle}>Login</Button>
            <Typography variant='body2' sx={{ textAlign: 'center', paddingTop: '10px', fontSize: '1rem' }}>Forgot your password?</Typography>
          </Box>
          
        </Card>

        </div>
      </div>
    </div></div>
    {/* <Container>
      <Row>
        <Col>aa</Col>
      </Row>
    </Container> */}

    {/* <Box sx={containerStyle}>
      <Box sx={{ width: '100%', height: 'auto', display: 'flex', justifyContent: 'end' }}>
        <Card sx={cardStyle}>
          <Box sx={{ justifyContent: 'center', marginTop: '80px' }}>
            <Avatar src={hnakLogo} alt='HNAK logo' sx={{ height: '90px', width: '90px' }} className="login-logo"/>
          </Box>
          <Box sx={{ margin: '5% 15% 2% !important', textAlign: 'center', padding: '20px 0px 10px', color: '#778899 !important', minHeight: '80px' }}>
            <Typography variant='body2' sx={{ fontSize: '1.3rem', fontWeight: 600 }}>
              Welcome, please sign in
            </Typography>
          </Box>
          {
            loginError && loginErrormsg != null && <Box>
              <Typography variant='body2' sx={{ textAlign: 'center', paddingTop: '10px', color: 'red', fontSize: '1rem', fontWeight: 600 }}>
                {loginErrormsg}
              </Typography>
            </Box>
          }
          <Box>
            <TextField label='Username' value={usernameVal} onChange={(e) => setUsernameval(e.target.value)}/>
            <TextField label='Password' value={passwordVal} onChange={(e) => setPasswordVal(e.target.value)} 
              type={showPass ? 'text' : 'password'}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPass(!showPass)}>
                      {showPass ? <VisibilityIcon/> : <VisibilityOffIcon/>}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
          />
          </Box>
          <Box sx={{ justifyContent: 'center', paddingTop: '30px' }}>
            <Button onClick={() => handleSignin()} sx={buttonStyle}>Login</Button>
            <Typography variant='body2' sx={{ textAlign: 'center', paddingTop: '10px', fontSize: '1rem' }}>Forgot your password?</Typography>
          </Box>
          
        </Card>
      </Box>
    </Box> */}
    </>
  )
}

export default LoginPage